'use client';
import { useAppContext } from '@/context/app';
import useIsMobile from '@/hooks/use-is-mobile';
import clsx from 'clsx';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import MiniCartLazyLoad from '../MiniCart/mini-cart-lazy-load';
import HeaderToolbar from './headerToolbar';

const HeaderClient = props => {
  const { announcements, navMenu } = props;
  const pathname = usePathname();
  const [miniCartOpen, setMiniCartOpen] = useState(false);
  const [showNoItemDrawer, setShowNoItemDrawer] = useState(false);
  const [lastAddToCartTimestamp, setLastAddToCartTimestamp] = useState(() => new Date().toString());
  const [isForAddToCartOk, setIsForAddToCartOk] = useState(false);
  const [{ headStickedOnTop, headerToolbarHeight }] = useAppContext();

  const prevPropsRef = useRef({
    miniCartOpen,
  });

  if (prevPropsRef.current.miniCartOpen !== miniCartOpen) {
    prevPropsRef.current.miniCartOpen = miniCartOpen;

    if (!miniCartOpen) {
      setIsForAddToCartOk(false);
    }
  }
  const isMobile = useIsMobile();

  useEffect(() => {
    const scrollAction = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      setMiniCartOpen(true);
      setLastAddToCartTimestamp(Date.now().toString());
      setIsForAddToCartOk(true);
    };

    document.addEventListener('CART_ADD_ITEM', scrollAction);

    return () => {
      document.removeEventListener('CART_ADD_ITEM', scrollAction);
    };
  }, []);

  if (pathname === '/checkout') {
    return null;
  }

  return (
    <>
      <header
        className={clsx(' duration-[400ms] sticky top-0 z-40 h-auto  w-full bg-white transition-all')}
        style={{
          transform: headStickedOnTop ? undefined : `translateY(-${headerToolbarHeight}px)`,
        }}
      >
        <HeaderToolbar
          announcements={announcements}
          miniCartOpen={miniCartOpen}
          setMiniCartOpen={setMiniCartOpen}
          setShowNoItemDrawer={setShowNoItemDrawer}
        />
        {!isMobile && navMenu}
      </header>
      <MiniCartLazyLoad
        isOpen={miniCartOpen}
        setIsOpen={setMiniCartOpen}
        showNoItemDrawer={showNoItemDrawer}
        setShowNoItemDrawer={setShowNoItemDrawer}
        lastAddToCartTimestamp={lastAddToCartTimestamp}
        isForAddToCartOk={isForAddToCartOk}
      />
    </>
  );
};

export default HeaderClient;
